import React from 'react';
import { localize } from '../Util/L10n';
import { getSelectedWorkshops } from '../Util';
import { SummaryList } from './SummaryList';

export const FormElement = React.memo(function ({
  id,
  selectBtnLabel,
  inputName,
  value,
  onOpenOverlayClick,
  workshops,
}) {
  const selectedWorkshops = getSelectedWorkshops(value, workshops);

  const filteredValues = Object.fromEntries(
    Object.entries(value).filter((v) => v[1])
  );

  return (
    <React.Fragment>
      <SummaryList selectedWorkshops={selectedWorkshops} />
      <button
        type="button"
        className="OpenWorkshopsOverlayButton"
        onClick={onOpenOverlayClick}
        data-id={id}
      >
        {selectBtnLabel || localize('openWorkshopsOverlayAction')}
      </button>
      <input
        name={inputName}
        type="hidden"
        value={JSON.stringify(filteredValues)}
      />
    </React.Fragment>
  );
});
